import * as C from "../constants/promoCodeConstants";

function getPromoCodes(payload = {}) {
  if (Array.isArray(payload?.promoCodes)) return payload.promoCodes;
  if (Array.isArray(payload)) return payload;
  return [];
}

function getPromoCode(payload = {}) {
  return payload?.promoCode || payload || null;
}

export const promoCodeAdminListReducer = (
  state = { promoCodes: [], page: 1, pages: 1, total: 0 },
  action,
) => {
  switch (action.type) {
    case C.PROMO_CODE_ADMIN_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case C.PROMO_CODE_ADMIN_LIST_SUCCESS:
      return {
        loading: false,
        promoCodes: getPromoCodes(action.payload),
        page: Number(action.payload?.page || 1),
        pages: Number(action.payload?.pages || 1),
        total: Number(action.payload?.total || action.payload?.count || 0),
      };
    case C.PROMO_CODE_ADMIN_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const promoCodeDetailsReducer = (
  state = { promoCode: null },
  action,
) => {
  switch (action.type) {
    case C.PROMO_CODE_DETAILS_REQUEST:
      return { loading: true, promoCode: null };
    case C.PROMO_CODE_DETAILS_SUCCESS:
      return { loading: false, promoCode: getPromoCode(action.payload) };
    case C.PROMO_CODE_DETAILS_FAIL:
      return { loading: false, error: action.payload, promoCode: null };
    default:
      return state;
  }
};

export const promoCodeCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case C.PROMO_CODE_CREATE_REQUEST:
      return { loading: true };
    case C.PROMO_CODE_CREATE_SUCCESS:
      return {
        loading: false,
        success: true,
        promoCode: getPromoCode(action.payload),
      };
    case C.PROMO_CODE_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case C.PROMO_CODE_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const promoCodeUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case C.PROMO_CODE_UPDATE_REQUEST:
      return { loading: true };
    case C.PROMO_CODE_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
        promoCode: getPromoCode(action.payload),
      };
    case C.PROMO_CODE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case C.PROMO_CODE_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const promoCodeDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case C.PROMO_CODE_DELETE_REQUEST:
      return { loading: true };
    case C.PROMO_CODE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case C.PROMO_CODE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case C.PROMO_CODE_DELETE_RESET:
      return {};
    default:
      return state;
  }
};
